import React from 'react'
import Layout from '../../component/Layout';
import Content from '../../component/CdnContent';
import { t } from 'i18next';

const CDNContainer = () => {
	return (
		<Layout title={t("cdn_page_title")} description={t("cdn_desc")}>
			<Content />
		</Layout>
	)
}

export default CDNContainer